import React from 'react';

export default function Navbar() {
  return (
    <div className='w-screen py-6 px-5 lg:px-64 bg-[#252525] flex justify-between text-white'>
      <span className='text-lg font-bold'>
        <a href="#home">CareerConnect</a>
      </span>

      <ul className='hidden md:flex items-center font-bold space-x-5'>
        <li>
          <a href="#home" className="hover:text-gray-300">Home</a>
        </li>
        <li>
          <a href="#about" className="hover:text-gray-300">About Us</a>
        </li>
        <li>
          <a href="#features" className="hover:text-gray-300">Features</a>
        </li>
        <li>
          <a href="#contact" className="hover:text-gray-300">Contact</a>
        </li>
      </ul>

      {/* Hamburger for Mobile */}
      <button className='space-y-1 group md:hidden'>
        <div className='w-6 h-1 bg-white'></div>
        <div className='w-6 h-1 bg-white'></div>
        <div className='w-6 h-1 bg-white'></div>

        <ul className='bg-[#252525] w-screen pb-10 absolute -top-full group-focus:top-0 right-0 duration-150 flex flex-col space-y-3 justify-end'>
          <button className='px-10 py-8 relative ml-auto'>
            <div className='w-6 h-1 rotate-45 absolute bg-white'></div>
            <div className='w-6 h-1 -rotate-45 absolute bg-white'></div>
          </button>
          <li className='flex justify-center w-full py-4 hover:bg-[#202020]'>
            <a href="#about">About</a>
          </li>
          <li className='flex justify-center w-full py-4 hover:bg-[#202020]'>
            <a href="#contact">Contact</a>
          </li>
          <li className='flex justify-center w-full py-4 hover:bg-[#202020]'>
            <a href="#features">Features</a>
          </li>
        </ul>
      </button>
    </div>
  );
}
